import React, { useMemo } from "react";
import { ECLRichTextViewer, ECLUserInfo } from "../../../../../index";
export default function CommentAdd({ comment, username, projectId }) {
   const date =
      new Date(comment.time).toDateString() +
      " " +
      new Date(comment.time).toLocaleTimeString();

   const viewer = useMemo(
      () => (
         <ECLRichTextViewer
            textAsMarkdown={comment.text}
            project_id={projectId}
         />
      ),
      [comment.text],
   );

   return (
      <article className={"comment-history-item comment-add"}>
         <div className="left">
            <ECLUserInfo user={comment.user} hideName={false}></ECLUserInfo>
         </div>
         <div className="right">
            <div className="top">
               <strong className="username">{username}</strong>
               {/* Dynamic Message Based On Comment Type */}
               <div className="comment-message">Added a Comment</div>
               <div className="date">{date}</div>
            </div>
            <div className="bottom">
               <div className="comment-action">Added comment:</div>
               <span className="text">{viewer}</span>
            </div>
         </div>
      </article>
   );
}
